module.exports = __webpack_public_path__ + "img/ggdb_tv_white.eacb442e.svg";